import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { mapBadge, activity } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function MyBoard() {
  const { state, go, L } = useApp();

  const myKpis = [
    { label: L('Open Invitations', 'คำเชิญที่เปิดอยู่'), value: '2', icon: 'inbox' },
    { label: L('Bids Submitted', 'ข้อเสนอที่ยื่นแล้ว'), value: '5', icon: 'gavel' },
    { label: L('Awards Won', 'สัญญาที่ได้รับ'), value: '3', icon: 'award' },
    { label: L('Performance Score', 'คะแนนผลงาน'), value: '92', icon: 'trending-up' },
  ];
  const myInvites = [
    { title: 'Fleet Vehicle Insurance — Class 1 Batch', id: 'RFQ-2026-001', value: '$4.85M', status: L('Bid Submitted', 'ยื่นข้อเสนอแล้ว'), ...mapBadge('Sent') },
    { title: 'Fleet Vehicle Insurance — Class 2 & 3', id: 'RFQ-2026-004', value: '$7.2M', status: L('Awaiting Bid', 'รอการเสนอราคา'), ...mapBadge('Pending') },
  ];
  const myActivity = [
    activity('check', 'ok', L('Award won — RFQ-2026-005', 'ได้รับสัญญา — RFQ-2026-005'), L('2d ago', '2 วันที่แล้ว')),
    activity('gavel', 'info', L('Bid submitted on RFQ-2026-001', 'ยื่นข้อเสนอใน RFQ-2026-001'), L('3d ago', '3 วันที่แล้ว')),
    activity('inbox', 'info', L('New invitation — RFQ-2026-004', 'คำเชิญใหม่ — RFQ-2026-004'), L('4d ago', '4 วันที่แล้ว')),
  ];
  const myFeedback = [
    { rfq: 'RFQ-2026-005', title: 'Maintenance Services', outcome: L('Awarded', 'มอบสัญญาแล้ว'), ...mapBadge('Awarded'), fb: L('Submitted', 'ส่งแล้ว') },
    { rfq: 'RFQ-2026-002', title: 'Spare Parts Q2', outcome: L('Not Selected', 'ไม่ได้รับเลือก'), ...mapBadge('Closed'), fb: L('Leave Feedback', 'ให้ความคิดเห็น') },
  ];

  return (
    <>
      <div data-tour="mykpis" style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {myKpis.map((k) => (
          <div key={k.label} style={cardPad(18)}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{k.label}</span>
              <Icon name={k.icon} style={{ color: 'var(--color-fg-3)' }} />
            </div>
            <div style={{ fontSize: 28, fontWeight: 700, fontFamily: 'var(--font-mono)' }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <div data-tour="invites" style={cardPad(20)}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
            <span style={{ fontWeight: 700 }}>{L('Open RFQ Invitations', 'คำเชิญ RFQ ที่เปิดอยู่')}</span>
            <button onClick={() => go('bidsubmit')} style={{ fontSize: 12, fontWeight: 600, color: '#fff', background: 'var(--color-primary)', padding: '6px 12px', borderRadius: 'var(--radius-sm)' }}>{L('Submit Bid', 'ยื่นข้อเสนอ')}</button>
          </div>
          {myInvites.map((r) => (
            <div key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--color-border)' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{r.title}</div>
                <div style={{ fontSize: 11, color: 'var(--color-fg-3)', fontFamily: 'var(--font-mono)' }}>{r.id} · {r.value}</div>
              </div>
              <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: r.stBg, color: r.stFg }}>{r.status}</span>
            </div>
          ))}
        </div>
        <div style={cardPad(20)}>
          <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Recent Activity', 'กิจกรรมล่าสุด')}</div>
          {myActivity.map((a, i) => (
            <div key={i} style={{ display: 'flex', gap: 11, padding: '9px 0', borderBottom: '1px solid var(--color-border)' }}>
              <div style={{ width: 26, height: 26, flex: 'none', borderRadius: 999, background: a.bg, color: a.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13 }}><Icon name={a.icon} /></div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13 }}>{a.text}</div>
                <div style={{ fontSize: 11, color: 'var(--color-fg-3)' }}>{a.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={cardPad(0, 'auto')}>
        <div style={{ padding: '14px 18px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('RFQ Feedback', 'ความคิดเห็น RFQ')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('RFQ', 'RFQ')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Title', 'ชื่อเรื่อง')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Outcome', 'ผลลัพธ์')}</th>
              <th style={{ textAlign: 'right', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Feedback', 'ความคิดเห็น')}</th>
            </tr>
          </thead>
          <tbody>
            {myFeedback.map((f, i) => (
              <tr key={i} style={{ borderBottom: '1px solid var(--color-border)' }}>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{f.rfq}</td>
                <td style={{ padding: '11px 16px' }}>{f.title}</td>
                <td style={{ padding: '11px 16px' }}><span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: f.stBg, color: f.stFg }}>{f.outcome}</span></td>
                <td style={{ padding: '11px 16px', textAlign: 'right' }}><button style={{ fontSize: 12, fontWeight: 600, color: 'var(--color-blue)' }}>{f.fb}</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
